// Type
export const SET_LANGUAGE = 'SET_LANGUAGE';

// Action
export const setLanguage = (lang) => async (dispatch) => {
  await dispatch({ type: SET_LANGUAGE, lang });
};

// Initial state; default to 'en'. Actual value is set on login/profile update.
const initState = {
  current: 'en',
};

const LanguageReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return { ...state, current: action.lang?.toLowerCase() === 'es' ? 'es' : 'en' };
    default:
      return state;
  }
};

export default LanguageReducer;
